import { render, staticRenderFns } from "./btc-video-card.vue?vue&type=template&id=135430e0&scoped=true&"
import script from "./btc-video-card.vue?vue&type=script&lang=js&"
export * from "./btc-video-card.vue?vue&type=script&lang=js&"
import style0 from "./btc-video-card.vue?vue&type=style&index=0&id=135430e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135430e0",
  null
  
)

export default component.exports